import * as React from 'react';
import {FunctionComponent} from 'react';
import {Crew} from '../../../../Models/Crew';
import {classNames} from '../../../Support/classNames';

interface OwnProps {
    crew: Crew;
    className?: string;
}

export const YourCrew: FunctionComponent<OwnProps> = ({crew, className}) => {
    return (
        <div className={classNames('card', className)}>
            <div className="card-title">
                <h5>Your crew</h5>
            </div>
            <div className="card-body">
                <dl>
                    <dt>Name</dt>
                    <dd>{crew.name}</dd>
                </dl>
                <dl>
                    <dt>Description</dt>
                    <dd>{crew.description}</dd>
                </dl>
                <dl>
                    <dt>Timezone</dt>
                    <dd>{crew.timezone}</dd>
                </dl>
                <div className="d-flex flex-row justify-content-end">
                    <a className="btn btn-outline-secondary" href={'/crews/' + crew.id + '/edit'}>
                        Edit
                    </a>
                </div>
            </div>
        </div>
    );
};
